import { render, staticRenderFns } from "./create_store.vue?vue&type=template&id=6b3ae2f2&"
import script from "./create_store.vue?vue&type=script&lang=js&"
export * from "./create_store.vue?vue&type=script&lang=js&"
import style0 from "./create_store.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VDialog,VDivider,VRow,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src327451746/src/bitbucket.org/iprosystems/customer-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3ae2f2')) {
      api.createRecord('6b3ae2f2', component.options)
    } else {
      api.reload('6b3ae2f2', component.options)
    }
    module.hot.accept("./create_store.vue?vue&type=template&id=6b3ae2f2&", function () {
      api.rerender('6b3ae2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/create_store.vue"
export default component.exports